// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","681":"component---cache-caches-gatsby-plugin-offline-app-shell-js"}[chunkId] + "-" + {"245":"49c4e9e895f0f91225b3","453":"fa9503984a6a8a11f236","681":"c2678f9811dc69770c33"}[chunkId] + ".js";
};